import React from "react";
import { FlexProps } from "../../Box";
import Flex from "../../Box/Flex";
import Dropdown from "../../Dropdown/Dropdown";
import Link from "../../Link/Link";
import { socials } from "../config";
import useMatchBreakpoints from "../../../contexts/MatchBreakpoints/useMatchBreakpoints";

/**
 * Site review 59 #8 (2026-10-08): the icons stay 20 px, every link is a 44 x 44 hit area (Bez's tap-target rule); the step between
 * icons is 44 on phones and 48 on desktop, so the areas never overlap.
 */
const HIT = "44px";

const SocialLinks: React.FC<React.PropsWithChildren<FlexProps>> = ({ ...props }) => {
  const { isMobile } = useMatchBreakpoints();

  return (
    <Flex {...props}>
      {socials.map((social, index) => {
        const iconProps = {
          width: "20px",
          color: "textSubtle",
          style: { cursor: "pointer" },
        };
        const Icon = social.icon;
        const mr = index < socials.length - 1 ? (isMobile ? "0px" : "4px") : 0;
        const hit = { display: "inline-flex", alignItems: "center", justifyContent: "center", minWidth: HIT, minHeight: HIT } as const;
        if (social.items) {
          return (
            <Dropdown key={social.label} position="top" target={<Icon {...iconProps} mr={mr} />}>
              {social.items.map((item) => (
                <Link external key={item.label} href={item.href} aria-label={item.label} color="textSubtle">
                  {item.label}
                </Link>
              ))}
            </Dropdown>
          );
        }
        return (
          <Link external key={social.label} href={social.href} aria-label={social.label} mr={mr} {...hit} data-hit="44">
            <Icon {...iconProps} />
          </Link>
        );
      })}
    </Flex>
  );
};

export default React.memo(SocialLinks, () => true);
